import config from '../config';
import {
  authHeader,
  customFetch,
  handleResponse,
  commonRequestOptions,
  subjects,
} from '../helpers';

const endpointPath = config.api.API_URL + '/job';

export const jobService = {
  getAll,
  getAllLatest,
  getById,
  getByTaskId,
  getLatestSync,
};

function getAll(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}

function getAllLatest(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/all_latest`, requestOptions, signal).then(handleResponse);
}

function getById(id, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/${id}`, requestOptions, signal)
    .then(handleResponse)
    .then(res => {
      if (!res) return;

      subjects.currentJob.next(res.jobs[0] || { job_id: id });
      subjects.currentTask.next(
        res.jobs[0]
          ? {
              task_id: res.jobs[0].task_id,
              task_name: res.jobs[0].task_name,
            }
          : 'not_found'
      );
      return res;
    });
}

function getByTaskId(id, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/task/${id}`, requestOptions, signal).then(handleResponse);
}

/**
 * Fetches the latest completed/warning dssync job per sync connection for the given asset.
 * @param {string} objectName - One of: datasource, dataset_group, dataset, field
 * @param {number} objectId - The asset's primary key value
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ jobs: Array }>}
 */
function getLatestSync(objectName, objectId, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(
    `${endpointPath}/latest_sync/${objectName}/${objectId}`,
    requestOptions,
    signal
  ).then(handleResponse);
}
